import { capitalize } from '../utils/capitalize'
import { parsePokemonTypes } from '../utils/pokemon'

import { useEffect, useState } from 'react'

const baseUrl = 'https://pokeapi.co/api/v2/pokemon/'

export const ABRA_ID = 63

export const usePokemon = (pokemonId = ABRA_ID) => {
  const [pokemon, setPokemon] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const getPokemon = async () => {
    setIsLoading(true)

    try {
      const response = await fetch(baseUrl + pokemonId)
      const apiPokemon = await response.json()

      // const imageUrl = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${apiPokemon.id}.png`
      const imageUrl = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${apiPokemon.id}.png`

      /* preload image in memory */
      await new Promise((resolve) => {
        const img = new Image()
        img.src = imageUrl
        img.onload = resolve
        img.onerror = resolve /* resolve too */
      })

      setPokemon({
        id: apiPokemon.id,
        name: capitalize(apiPokemon.name),
        imageUrl,
        types: parsePokemonTypes(apiPokemon.types),
      })
    } catch (err) {
      setPokemon({})
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getPokemon(pokemonId)
  }, [pokemonId])

  return {
    pokemon,
    isLoading,
    isAbra: pokemon.id === ABRA_ID
  }
}

